import { apiRequest } from '@peruselab/api-client/httpRequest';
import type { Evidence } from './Evidence';

export async function getRelationshipEvidence(relationshipId: string): Promise<readonly Evidence[]> {
  return apiRequest<Evidence[]>(`/scientific-relationships/${encodeURIComponent(relationshipId)}/evidence`, 'evidence');
}
